import { FC, useContext, useEffect, useId, useRef } from 'react';

import { SnackbarContext } from '@hh.ru/magritte-ui-snackbar/context';
import { SnackbarProps, SnackbarTransitionName } from '@hh.ru/magritte-ui-snackbar/types';

export const Snackbar: FC<SnackbarProps> = ({ removeOnUnmount = true, ...rest }) => {
    const context = useContext(SnackbarContext);
    const uid = useId();
    const removeOnUnmountRef = useRef(removeOnUnmount);
    removeOnUnmountRef.current = removeOnUnmount;

    useEffect(() => {
        context.animateIn(uid, rest);
    }, [context, uid, rest]);

    useEffect(() => {
        return () => {
            if (!removeOnUnmountRef.current) {
                return;
            }

            context.animateOut(
                uid,
                context.isShown(uid) ? SnackbarTransitionName.Hide : SnackbarTransitionName.RemoveImmediately
            );
        };
    }, [context, uid]);

    return null;
};
